import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOnOutlined';
import MailIcon from '@mui/icons-material/MailOutline';
import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import { FilterList, FilterListItem, SavedQueriesList } from 'react-admin';
//import { SavedQueriesList } from '@react-admin/ra-preferences';
import {
    endOfYesterday,
    startOfWeek,
    subWeeks,
    startOfMonth,
    subMonths,
} from 'date-fns';

import SubscriberIcon from '@mui/icons-material/Domain';
import ProductIcon from '@mui/icons-material/LibraryBooks';
import StatusIcon from '@mui/icons-material/CheckCircle';

import CustomFilterList from '../controls/CustomFilterList';
import CustomFilterSearch from '../controls/CustomFilterSearch';
import MinLengthFilterLiveSearch from '../controls/MinLengthFilterLiveSearch';
import ActivationCodeSearch from './ActivationCodeSearch';

const SubscriptionListAside = () => (
    <div
        style={{
            display: 'flex',
            flexDirection: 'column',
            order: -1,
            flex: '0 0 15em',
            marginRight: '16px',
            marginTop: '36px',
            alignSelf: 'flex-start',
        }}
    >
        <Card
            sx={{
                display: {
                    xs: 'none',
                    md: 'block',
                },
            }}
        >
            <CardContent sx={{ pt: 1 }}>
                <MinLengthFilterLiveSearch
                    source="q"
                    variant="outlined"
                    minLength={3}
                />
                <SavedQueriesList />
                <CustomFilterSearch
                    url="extralist/subscription/products"
                    label="resources.subscription.filters.products"
                    source="product_guid"
                    variant="filled"
                    storeKey="subscription.filters.product_guid"
                    icon={<ProductIcon />}
                />
                <CustomFilterSearch
                    url="extralist/subscription/subscribers"
                    label="resources.subscription.filters.subscribers"
                    source="subscriber_guid"
                    variant="filled"
                    storeKey="subscription.filters.subscribers"
                    //storeKeyToClear="store.subscription.subscriber_users"
                    icon={<SubscriberIcon />}
                />
                <CustomFilterList
                    url="extralist/subscription/isvalid"
                    label="resources.subscription.filters.isvalid"
                    source="isvalid"
                    icon={<StatusIcon />}
                />
                <CustomFilterList
                    url="extralist/subscription/statuses"
                    label="resources.subscription.filters.status"
                    source="status"
                    icon={<StatusIcon />}
                />
            </CardContent>
        </Card>
        <ActivationCodeSearch />
    </div>
);

export default SubscriptionListAside;
